import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Paper,
  Toolbar,
  List,
  ListItem,
  Divider,
  Grid,
  Avatar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material";
import Badge from "@mui/material/Badge";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ListItemButton } from "@mui/material";
import { CiMenuBurger } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { MdLogout } from "react-icons/md";
import { ImRadioChecked } from "react-icons/im";
import { BsFileEarmarkCheckFill } from "react-icons/bs";
import { HiDocumentSearch } from "react-icons/hi";
import { IoIosSettings } from "react-icons/io";
import PSCLogo from "../../Assets/Logo/PSCLogo.svg";
import Notification from "./Notification";
import CommonRoutes from "../Routes/CommonRoutes";
import LogoutModal from "./LogoutModal";
import { GetMethod, GetPublicURL, PostMethod } from "../../Helper/api";

const drawerWidth = 225;
export default function SideBar(props) {
  const { window } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [MobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [ProfileData, setProfileData] = useState("");
  const [ProfileDataImage, setProfileDataImage] = useState("");

  const [NotificationList, setNotificationList] = useState([]);
  const [joblist, setjoblist] = useState(0);

  const [open, setOpen] = useState(true);
  const [logoutModal, setLogoutModal] = useState(false);
  const { ProfileUpdate } = useSelector((state) => state.Reducer);

  const OpenSideaBars = (item) => {
    if (item.name == "Applicants") {
      setOpen((prev) => !prev)
    }
  }
  const SidebarSubLink = styled(Link)(() => ({
    display: "flex",
    color: "#7e8993",
    fontFamily: "poppinsRegular",
    justifyContent: "space-between",
    "&:hover": {
      textDecoration: "none",
      fontFamily: "poppinsRegular",
      backgroundColor: "transparent"
    },
    "&:active": {
      textDecoration: "none",
      fontFamily: "poppinsMedium",
    },
    "&:focus": {
      textDecoration: "none",
      fontFamily: "poppinsMedium",
    },
  }));
  useEffect(() => {
    let UserData = JSON.parse(localStorage.getItem("@users"));
    setProfileData(UserData)
    GetNotificationList()
    GetJoblist()
  }, [])
  useEffect(()=>{
    GetprofileImages()
  },[ProfileData?.image])
  const GetprofileImages= async()=>{
    const image =await GetPublicURL(ProfileData?.image)
    if(image){
      setProfileDataImage(image)
    }
  }
  useEffect(() => {
    if (ProfileUpdate) {
      let UserData = JSON.parse(localStorage.getItem("@users"));
      setProfileData(UserData);
      dispatch({
        type: "ProfileUpdateAction",
        payload: { ProfileUpdate: false },
      });

    }
  }, [ProfileUpdate])
  const GetJoblist = async () => {
   
    let url = "job/candidatejobcount";
    let method = "GET";
    try{
      const response = await GetMethod({ url, method });
      if(response.status){
        if(response.result ){
          setjoblist(response.result.count)
        }
      }
    }catch(Error){
      console.log("Error",Error)
    }
  }
  const GetNotificationList = async () => {
    const Userid =localStorage.getItem("@userid")
    try{
      let url="notifications/list"
      let method = "POST";
      let params ={
        candidate_uuid:Userid
      }
      const response = await PostMethod({ url, method,params });
      if(response.status){
        if(response.result ){
          setNotificationList(response.result)
        }
      }
    }catch(Error){
      console.log("Error",Error)
      setNotificationList([]);
    }
  }
  const HandleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const HandleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };
  const HandleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!MobileOpen);
    }
  };
  const CandidateDataSideBarData = [
    {
      id: 1,
      name: "Job Opening",
      route: "/",
      icon: HiDocumentSearch,
      isSelected: true,
      count:5,
      countEnable: false,
    },

    {
      id: 2,
      name: "Applied Jobs",
      route: "/appliedjobs",
      icon: BsFileEarmarkCheckFill ,
      isSelected: true,
      countEnable: false,
    },
    {
      id: 4,
      name: "Settings",
      route: "/settings/profile",
      icon: IoIosSettings,
      isSelected: true,
      countEnable: false,
    },
    {
      id: 4,
      name: "Logout",
      route: "/logout",
      icon: MdLogout,
      isSelected: true,
      countEnable: false,
    },

  ];
  const Locationfilter = () => {
    var CurrentLocation = location.pathname?.split("/");
    if (location.pathname == "/") {
      return "/";
    } else if (CurrentLocation[1] == "dashboard"|| CurrentLocation[1] =="apply") {
      return "/";
    } else if (CurrentLocation[1] == "appliedjobs") {
      return "/appliedjobs";
    } else if (CurrentLocation[1] == "computerbasedtest") {
      return "/computerbasedtest";
    } else if (CurrentLocation[1] == "settings") {
      return "/settings/profile";
    }
  };
  const NavigateTo = (data) => {
    if (data == "/logout") {
      setLogoutModal(true)
    } else {
      navigate(data);
    }
  };
  const BatchCustom = styled(Badge)(() => ({
    ".MuiBadge-badge": {
      fontFamily: "PoppinsMedium",
      fontSize: "10px",
      backgroundColor: "#E62A4A",
      color: "#FFFFFF",
    },
  }));
  const drawer = (
    <Grid
      container
      display={"flex"}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Toolbar style={{ height: "10vh" }}>
        <img src={PSCLogo} alt="PSCLogo" className="img_fluid" />
        <h5 className="Text-Prime-White poppinsSemiBold"> Police Service Commission</h5>
      </Toolbar>
      <Divider />
      <List >
        {CandidateDataSideBarData.map((item, index) => (
          <>
            <ListItem
              key={index}
              disablePadding
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
              onClick={() =>
                item.subNav ? OpenSideaBars(item) : NavigateTo(item.route)
              }

            >
              <button
                className="btn btn-0 border-0 mt-4 py-2 ButtonFoucusNone"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "90%",
                  backgroundColor: item.route == Locationfilter() ? "#0FBE7C" : "transparent",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <Grid item container flexDirection={"row"} alignItems={"center"} className="ml-4">
                  {item.icon ? <item.icon size={20} className={item.route == Locationfilter() ? "text-black" : "text-white"} /> : ""}
                  <p className={item.route == Locationfilter() ? "mx-2 poppinsSemiBold text-black" : "mx-2 poppinsSemiBold text-white"} >{item?.name}</p>
                </Grid>
                <Grid style={{
                  display: item.subNav ? "flex" : "none", justifyContent: "flex-end"
                }} >
                  {item.subNav && open
                    ? item.iconOpened
                    : item.subNav
                      ? item.iconClosed
                      : null}
                </Grid>
                {item.name=="Job Opening"&& <BatchCustom badgeContent={joblist} overlap="circular"></BatchCustom>}
              </button>
            </ListItem>
            <Grid item container flexDirection={"row"} alignItems={"center"}>
              {open &&
                item.subNav?.map((val, ValIndex) => {
                  return (
                    <SidebarSubLink key={ValIndex} to={val.route} className="pl-4" >
                      <ListItemButton
                        sx={{
                          justifyContent: open ? "initial" : "center",
                        }}
                        onClick={() => { navigate(val.route) }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                            color: (val.route == location.pathname ? "#0FBE7C" : "#FFFFFF"),
                            alignItems: "center"
                          }}
                        >
                          <ImRadioChecked className="ml-2 " />
                          <p className="m-0 pl-2 poppinsRegular" style={{ display: open ? "block" : "none" }}>{val.name}</p>
                        </ListItemIcon>
                      </ListItemButton>
                    </SidebarSubLink >
                  );
                })
              }
            </Grid>
          </>
        ))}

      </List>
    </Grid>
  );
  const container = window !== undefined ? () => window().document.body : undefined;
  

  return (
    <Paper
      className="w-100 rounded-0 CustomScroll"
      style={{
        backgroundColor: "#F5F7FB",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
      }}
    >
      <CssBaseline />
      {!String(location?.pathname).includes("CallLetter") && !String(location?.pathname).includes("result")  && !String(location?.pathname).includes("OfferLetterview") &&  <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: "#FFFFFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: { sm: "space-between", xs: "flex-start" },
            padding: "5px",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={HandleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <CiMenuBurger />
          </IconButton>
          <Grid item container justifyContent={"flex-end"} alignItems={"flex-end"}>
            <Notification NotificationList={NotificationList} GetNotificationList={GetNotificationList} />
            {ProfileDataImage? <Avatar src={ProfileDataImage} style={{ height: "50px", width: "50px" }} />: <Avatar src={null} style={{ height: "50px", width: "50px" }} />}
            <Grid
              className="mx-3"
              display={"flex"}
              flexDirection={"column"}
              alignItems={"flex-start"}
              alignContent={"center"}
              alignSelf={"center"}
            >
              <p className="Text-Prime-Black poppinsMedium" style={{ textTransform: "capitalize", fontSize: "17px"}}>
                {ProfileData?.first_name + " " + ProfileData?.last_name}
              </p>
              <p className="Text-Prime-Gray poppinsRegular" style={{ fontSize: "12px" }} >{" "}</p>

            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>}
      {!String(location?.pathname).includes("CallLetter")&& !String(location?.pathname).includes("result")  && !String(location?.pathname).includes("OfferLetterview") &&  <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={MobileOpen}
          onTransitionEnd={HandleDrawerTransitionEnd}
          onClose={HandleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#333333",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "#333333",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {!String(location?.pathname).includes("CallLetter") && !String(location?.pathname).includes("result")  && !String(location?.pathname).includes("OfferLetterview") &&   <Toolbar />}
       
        <CommonRoutes />
        <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
      </Box>
    </Paper>
  );
}
